import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function StickyCallBar() {
  return <div className="fixed bottom-0 left-0 right-0 z-50" data-id="element-140">
      <a href="tel:+19252151160" className="flex items-center justify-center gap-2 w-full bg-gold hover:bg-gold-dark text-white font-sans font-bold uppercase tracking-wider text-sm py-4 transition-colors duration-300" data-id="element-141">
        <PhoneIcon className="w-4 h-4" data-id="element-142" />
        (925) 215-1160
      </a>
    </div>;
}